<template>
  <div>
    <b-modal
      no-fade
      size="xl2"
      id="modal-nivel"
      no-close-on-esc
      no-close-on-backdrop
      :title="getTitle"
      @show="loadCombos()"
    >
      <input type="hidden" id="wbs_id" v-model="wbs.wbs_id" />
      <input type="hidden" id="ind_analitico" v-model="wbs.ind_analitico" />
      <b-tabs content-class="v-tab-content" v-model="tabIndex" active-nav-item-class="v-tab-active" small>
        <b-tab title="Nível EAP">
          <b-form-row>
            <b-col lg="12">
              <TabWBS :wbs="wbs" acao="acao" :combos="combos" />
            </b-col>
          </b-form-row>
        </b-tab>
        <b-tab :disabled="acao == 'new'" title="Licitação">
          <b-form-row>
            <b-col lg="12">
              <TabLicitacao :wbs="wbs" :acao="acao" />
            </b-col>
          </b-form-row>
        </b-tab>
        <b-tab :disabled="acao == 'new'" title="Contrato">
          <b-form-row>
            <b-col lg="12">
              <TabContrato :wbs="wbs" :acao="acao" />
            </b-col>
          </b-form-row>
        </b-tab>
        <b-tab :disabled="acao == 'new'" title="Financeiro">
          <TabFinanceiro :wbs="wbs" :acao="acao" :sintetico="false" />
        </b-tab>
        <b-tab :disabled="acao == 'new'" title="Planejamento">
          <b-form-row>
            <b-col lg="12">
              <TabPlanejamento :wbs="wbs" :acao="acao" />
            </b-col>
          </b-form-row>
        </b-tab>
        <b-tab :disabled="acao == 'new'" title="Anexos">
          <b-form-row>
            <b-col lg="12">
              <TabAnexos :wbs="wbs" :acao="acao" />
            </b-col>
          </b-form-row>
        </b-tab>
      </b-tabs>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="saveWBS()" variant="primary"> <i class="fas fa-check"></i> Gravar </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-nivel')">Cancelar</b-button>
      </template>
    </b-modal>
    <UIBlocker ref="divWait" :isShow="isSaving"> Gravando Dados. Aguarde... </UIBlocker>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError, formatDate } from "@/global";

import TabWBS from "./TabWBS";
import TabLicitacao from "./TabLicitacao";
import TabContrato from "./TabContrato";
import TabPlanejamento from "./TabPlanejamento";
import TabFinanceiro from "./TabFinanceiro";
import TabAnexos from "./TabAnexos";

import { bidbus } from "@/main";
import UIBlocker from "@/components/layout/UIBlocker";
export default {
  name: "ModalNivel",
  components: {
    TabWBS,
    TabLicitacao,
    TabContrato,
    TabPlanejamento,
    TabFinanceiro,
    TabAnexos,
    UIBlocker,
  },
  computed: {
    getTitle: function() {
      let _titulo = "";
      _titulo = `Nível EAP - ${this.wbs.wbs_id} - ${
        this.wbs.componente == undefined ? "" : this.wbs.componente.substring(0, 50)
      }`;

      return _titulo;
    },
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  data: function() {
    return {
      isSaving: false,
      tabIndex: 0,
      combos: {
        moedas: [],
        tiposContrato: [],
        tiposServico: [],
      },
    };
  },
  methods: {
    validateWBS() {
      if ((this.wbs.moeda_id || "") === "") this.wbs.moeda_id = 0;

      let _msg = "";

      if ((this.wbs.componente || "") === "") _msg = "Informe o Componente";

      if ((this.wbs.item_pa || "") === "") _msg += (_msg !== "" ? "<br/>" : "") + "Informe o Item PA!";

      if ((this.wbs.ind_fonte || "") === "") _msg += (_msg !== "" ? "<br/>" : "") + "Selecione a Fonte!";

      if ((this.wbs.ind_fonte || "") === "1" && this.wbs.montante_estim_bid <= 0)
        _msg += (_msg !== "" ? "<br/>" : "") + "Montante BID inválido!";

      if ((this.wbs.ind_tp_contratacao || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Tipo de Contratação!";

      if ((this.wbs.tipo_contrato_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Tipo de Contrato!";

      if ((this.wbs.tipo_servico_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Tipo de Serviço!";

      if ((this.wbs.cotacao_base || 0) == 0) this.wbs.cotacao_base = 1;

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
        return false;
      }
      return true;
    },
    trataData(data) {
      if (data || "" != "") return formatDate(data, "DD/MM/YYYY", "YYYY-MM-DD");
      else return null;
    },
    saveWBS() {
      let _saveObj = { ...this.wbs };

      if (!this.validateWBS()) return;

      _saveObj.cotacao_base = parseFloat(_saveObj.cotacao_base);
      this.isSaving = true;
      if (this.acao === "new") {
        axios
          .post(`${baseApiUrl}/bid/programawbs/${btoa(this.wbs.programa_id)}`, _saveObj)
          .then((resp) => {
            this.$emit("insertedWBS", resp.data);
            this.isSaving = false;
            return;
          })
          .catch((err) => {
            this.isSaving = false;
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/bid/programawbs/${btoa(this.wbs.programa_id)}/${this.wbs.wbs_id}`, _saveObj)
          .then(() => {
            this.isSaving = false;
            this.$toasted.success("Registro gravado com sucesso", {
              keepOnHover: true,
              duration: 2500,
            });
            this.$emit("updatedWBS");
            bidbus.$emit("updatedWBS");
          })
          .catch((err) => {
            this.isSaving = false;
            showError(err);
          });
      }
    },
    loadCombos() {
      this.tabIndex = 0;
      // moedas
      axios
        .get(`${baseApiUrl}/bid/moedas`)
        .then((resp) => {
          resp.data.splice(0, 1);
          resp.data.unshift({
            moeda_id: 1,
            sigla: "Nenhuma",
            descricao: "Nenhuma",
          });
          this.combos.moedas = resp.data;
        })
        .catch(showError);

      // tipos de contrato
      axios
        .get(`${baseApiUrl}/bid/tiposcontrato`)
        .then((resp) => {
          this.combos.tiposContrato = resp.data;
        })
        .catch(showError);

      // tipos de servico
      axios
        .get(`${baseApiUrl}/bid/tiposservico`)
        .then((resp) => {
          this.combos.tiposServico = resp.data;
        })
        .catch(showError);
    },
  },
  watch: {
    acao: function() {},
  },
};
</script>

<style></style>
